export default __webpack_public_path__ + "static/media/newpic.f82d9124.svg";